const MILLISECONDS_PER_SECOND = 1000;

const decodeBase64Url = (segment: string): string => {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);

  return atob(base64 + padding);
};

export const decodeJwtExpiration = (token: string): number | null => {
  try {
    const payloadSegment = token.split(".")[1];
    if (!payloadSegment) return null;

    const payload = JSON.parse(decodeBase64Url(payloadSegment));
    if (typeof payload.exp !== "number") return null;

    return payload.exp * MILLISECONDS_PER_SECOND;
  } catch {
    return null;
  }
};

export const isTokenExpiringSoon = (
  token: string,
  thresholdMs: number,
  now: number = Date.now(),
): boolean => {
  const expiration = decodeJwtExpiration(token);
  if (expiration === null) return true;

  return expiration - now < thresholdMs;
};
